import * as React from 'react'
import { observer } from 'mobx-react'
import styles from './InfiniteScrollLoader.sass'
import InfiniteScrollProvider from 'utils/InfiniteScrollProvider'
import Spinner from 'components/Spinner'
import { useInfiniteScroll } from 'hooks/infinite-scroll'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  scrollProvider: InfiniteScrollProvider<any, any>
  compact?: boolean
}

export default observer(function InfiniteScrollLoader({
  scrollProvider,
  compact,
}: Props) {
  const ref = React.useRef<HTMLDivElement>(null)
  const { isDone } = useInfiniteScroll(ref, scrollProvider)
  if (isDone) {
    return <div className={compact ? styles.compact : styles.root} />
  }
  return (
    <div className={styles.root} ref={ref}>
      <Spinner />
    </div>
  )
})
